import React from 'react';
import { Menu } from 'lucide-react';
import UserMenu from './UserMenu';
import { NotificationBell } from './NotificationComponents';
import BrandLogo from './BrandLogo';

/**
 * TopNavBar - Header Layout
 * 
 * Left:  Hamburger (mobile only) + BrandLogo (TradeLife + theme emblem)
 * Right: Notification bell + Avatar menu
 * 
 * On desktop (lg+): hamburger is hidden (sidebar handles navigation)
 * On mobile (<lg): hamburger toggles MobileDrawer
 */
export function TopNavBar({ onMenuToggle }) {
  return (
    <header className="top-nav-bar" data-testid="top-nav-bar">
      <div className="top-nav-left">
        {/* Hamburger — mobile only */}
        <button 
          className="mobile-menu-toggle"
          onClick={onMenuToggle}
          aria-label="Open navigation menu"
          data-testid="mobile-menu-toggle-btn"
        >
          <Menu size={22} />
        </button>
        <BrandLogo showEmblem={true} linkTo="/command-centre" variant="header" />
      </div>
      <div className="top-nav-right">
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  );
}

export default TopNavBar;
